import PropTypes from 'prop-types';
import React from 'react';

import FullscreenTemplate from '../../sp-base-templates/FullscreenTemplate';
import Slideshow from '../../components/Slideshow/Slideshow';

export default function SlideshowTemplate(_ref) {
  var onClose = _ref.onClose,
      slides = _ref.slides;

  return React.createElement(
    FullscreenTemplate,
    { onClose: onClose },
    React.createElement(Slideshow, { slides: slides })
  );
}

SlideshowTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  onClose: PropTypes.func,
  slides: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    path: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    scaling: PropTypes.string,
    text: PropTypes.string,
    audioSource: PropTypes.string
  }))
} : {};

SlideshowTemplate.defaultProps = {
  onClose: function onClose() {},
  slides: []
};